import { ApplicationConfig, isDevMode, LOCALE_ID } from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  withPreloading,
} from '@angular/router';
import { appRoutes } from './app.routes';
import { environment } from '../environments/environment';
import { provideAuth } from '@lyceo/shared/auth/feature-main';
import { provideSentry } from '@techniek-team/sentry-web';
import { provideStore } from '@ngrx/store';
import {
  provideRouterStore,
  routerReducer,
  RouterState,
} from '@ngrx/router-store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { Drivers, provideStorage } from '@techniek-team/common';
import { provideAlfredClient } from '@lyceo/alfred-client';
import { sessionReducer } from './+state/session/session.reducer';
import { provideEffects } from '@ngrx/effects';
import { SessionEffects } from './+state/session/session.effects';
import { provideApplicationStore } from '@lyceo/shared/data-access';
import { provideTransloco } from '@jsverse/transloco';
import { TranslocoHttpLoaderService } from '@lyceo/shared/translate/feature-main';

registerLocaleData(localeNl, 'nl');

const ALFRED_WEB_APP_STORAGE: string = '__lyceo-alfred-web-app';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'nl-NL' },
    provideRouter(appRoutes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptorsFromDi()),
    provideStore({
      router: routerReducer,
      session: sessionReducer,
    }),
    provideEffects(SessionEffects),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true,
      features: {
        pause: false,
        lock: true,
      },
      connectInZone: true,
    }),
    provideRouterStore({
      routerState: RouterState.Minimal,
    }),
    provideAuth({
      oAuthConfig: environment.authConfig,
      authModuleConfig: environment.authModuleConfig,
      storagePrefix: ALFRED_WEB_APP_STORAGE,
      initialize: true,
      setSentryUser: true,
    }),
    provideIonicAngular({
      useSetInputAPI: true,
    }),
    provideSentry(
      {
        environment: environment.environment,
        dsn: environment.sentryDsn,
        release: environment.release,
        autoSessionTracking: true,
        enableTracing: true,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        profilesSampleRate: 0,
      },
      //withTracing(),
    ),
    provideStorage({
      name: ALFRED_WEB_APP_STORAGE,
      driverOrder: [Drivers.LocalStorage],
    }),
    provideAlfredClient({
      alfredApiUrl: environment.alfredApiUrl,
      production: environment.production,
      biebApiUrl: environment.biebApiUrl,
      autoFocus: true,
    }),
    provideApplicationStore(),
    provideTransloco({
      config: {
        availableLangs: ['nl'],
        defaultLang: 'nl',
        reRenderOnLangChange: false,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoaderService,
    }),
  ],
};
